<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i>
            Settings
            <records-count :total="pageInfo.totalItems" />
            <div class="pull-right tools">
              <b-button
                @click="addSetting"
                size="sm"
                title="Add Setting"
                variant="primary">
                  <i class="fa fa-edit" aria-hidden="true"></i> Add setting
              </b-button>
            </div>
          </div>
          <div class="card-body">
            <grid-component
              isResizable
              isReorderable
              :pageable="pageable"
              :pageSizes="pageInfo.pageSize"
              :totalItems="pageInfo.totalItems"
              :gridId="gridId"
              :itemData="allSettings"
              :sortBy="pageInfo.sortBy"
              :sortOrder="pageInfo.sortOrder"
              :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
              :take="pageInfo.pageSize"
              :sortMethod="sortGrid"
              :fields="fields"
              :onEdit="editSetting"
              :styleCustom="'height: 800px'"
              @getData="onGetData"
              />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { PAGE_SIZE,GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';
import fields from './fields';

export default {
  components: {
    GridComponent
  },
  data() {
    return {
      fields,
      pageSize: PAGE_SIZE,
      currentPage: 1,
      gridId: GRID_ID.SETTINGS_GRID,
      
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
    };
  },
  metaInfo: () => ({
    title: 'Settings',
  }),
  computed: {
    ...mapGetters('settings', ['allSettings', 'pageInfo']),
  },
  methods: {
    ...mapActions('settings', ['getAll', 'sortGrid']),
    async onGetData(params) {
			await this.getAll(params);
		},
    editSetting(item) {
      this.$router.push({ name: 'EditSetting', params: { id: item.id } });
    },
    addSetting() {
      this.$router.push({ name: 'AddSetting' });
    },
  },
  created() {
    this.getAll({});
  },
};
</script>

<style lang="scss">
.tools > * {
  margin: 0 0 0 3px;
}
.b-pagination {
  justify-content: center;
}
table td {
  cursor: pointer;
  white-space: nowrap;
}
</style>
